import { ProjectMember } from '@ih/app/shared/apis/interfaces';

export class FindAllDefaultRoles {
  public static readonly type =
    '[Project/ProjectMember/List] FindAllDefaultRoles';
  constructor(public readonly projectMembers: ProjectMember[]) {}
}
